import { required, decimal, integer } from '@vuelidate/validators'

export const CategoriesActionsValidation = {
    name: { required },
    volume: { required, decimal },
    capacity: { required, integer },
}
